export default __webpack_public_path__ + "static/bars-cb6c7629ae81b5937367d225febb81ba.png";